module.exports = __webpack_public_path__ + "img/asiclogo.35e52aaa.png";